import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/*
    🔥 SCROLL TO TOP DE ROUTING

    Por defecto, cada cambio real de pantalla empieza arriba.

    Excepción 1: el caller puede navegar con:
        state: { preserveScroll: true }

    Excepción 2: las subrutas del detalle de curso del alumno representan
    modales de LA MISMA pantalla:
        /student/courses/:id
        /student/courses/:id/classes
        /student/courses/:id/materials
        ...

    Cambiar entre esas rutas no debe mover el viewport. Esto también cubre
    cerrar con el botón Atrás del navegador, no solamente con la X del modal.
*/
const modalDetailRoot = (pathname = "") => {
    const studentMatch = String(pathname).match(/^\/student\/courses\/([^/]+)(?:\/[^/]+)?\/?$/);
    if (studentMatch) return `/student/courses/${studentMatch[1]}`;

    const instructorMatch = String(pathname).match(/^\/instructor\/cohorts\/([^/]+)(?:\/[^/]+)?\/?$/);
    return instructorMatch ? `/instructor/cohorts/${instructorMatch[1]}` : null;
};

export const ScrollToTop = () => {
    const { pathname, state } = useLocation();
    const previousPath = useRef(null);

    useEffect(() => {
        const previous = previousPath.current;
        const previousRoot = modalDetailRoot(previous);
        const currentRoot = modalDetailRoot(pathname);
        const isSameModalDetail = !!previousRoot && previousRoot === currentRoot;

        if (state?.preserveScroll !== true && !isSameModalDetail) {
            window.scrollTo(0, 0);
        }

        previousPath.current = pathname;
    }, [pathname, state?.preserveScroll]);

    return null;
};
